import { IKioskRepository } from "../../../domains/kiosk/interfaces/repositories/IKioskRepository";
import { IHttpRepository } from "../../interfaces/IHttpRepository";
import { ILocalStorageRepository } from "../../interfaces/ILocalStorageRepository";
import { IConfigRepository } from "../../interfaces/IConfigRepository";
import { ConfigTotemMeep, configTotemMeepToKiosk } from "./ConfigTotemMeep";
import { Kiosk } from "../../../domains/kiosk/aggregates/Kiosk";
import { HttpRepository } from "./_HttpRepository";
import { EventSessionStorage } from "../localStorage/EventSessionStorage";
import { LocalStorageRepository } from "../localStorage/_LocalStorageRepository";
import { CefSharpConfigRepository } from "../../services/cefSharpService/local/CefSharpConfigRepository";
import enviroment from "corss-cutting/enviroment";

const keyStorage = "@kiosk";

export const KioskRepository = (
): IKioskRepository => {

  const httpRepository: IHttpRepository = HttpRepository();
  const localStorageRepository: ILocalStorageRepository = LocalStorageRepository();
  const eventSessionStorage = EventSessionStorage();
  const config: IConfigRepository = CefSharpConfigRepository();

  const syncAsync = async () => {
    const configs = await config.getConfigAsync()
    const reponseConfigMeep = await httpRepository.postAsync<any, ConfigTotemMeep>
      ("/UsuarioMeepPOS/AtualizarDadosEquipamento",
        {
          IMEI: configs.macAddress,
          // IMEI: '00215D299378',
          UsuarioMeepPOSId: configs.equipamentId,
          VersaoReactTotem: enviroment.appVersion
        }
      )
    localStorageRepository.post(keyStorage, configTotemMeepToKiosk(reponseConfigMeep));
    console.log("sync configKiosk", configs);
    const kiosk = configTotemMeepToKiosk(reponseConfigMeep);
    return {
      ...kiosk,
      token: configs.token,
      eventSessionId: await eventSessionStorage.getSessionIdAsync(
        kiosk.registroSessaoPOSId
      ),
    };
  };


  const getAsync = async (): Promise<Kiosk | null> => {
    let kioskValues: Kiosk | null = await localStorageRepository.get<Kiosk>(
      keyStorage
    );
    if (!kioskValues) {
      return null;
    }
    return {
      ...kioskValues,
      eventSessionId: await eventSessionStorage.getSessionIdAsync(
        kioskValues.registroSessaoPOSId
      ),
    };
  };



  return { getAsync, syncAsync };
};

